import { NotAvailableError } from "@baseline/common/errors";
import { ClassRef, InterfaceRef } from "@baseline/common/types";


export class Registry extends Map<ClassRef | InterfaceRef, any>
{
    add<T>(service: T): T;
    add<T>(service: T, type: ClassRef<T> | InterfaceRef<T>): T;
    add<T>(service: T, type?: ClassRef<T> | InterfaceRef<T>): T
    {
        const serviceType = type ?? (service.constructor as ClassRef<T>);
        if (this.get(serviceType))
            throw new NotAvailableError(`Service already exists in registry: ${serviceType.name}.`);
        this.set(serviceType, service);
        return service;
    }

    use<T>(service: T): this;
    use<T>(service: T, type: ClassRef<T> | InterfaceRef<T>): this;
    use<T>(service: T, type?: ClassRef<T> | InterfaceRef<T>): this
    {
        this.add(service, type);
        return this;
    }
}


export namespace Registry
{
    export function create(): Registry
    {
        const registry = new Registry();
        registry.set(Registry, registry);
        return registry;
    }
}
